// Import React and Hero section styles
import React from "react";
import "../../css/components/Hero.css";

// Helper function to render multi-line text with <br />
const renderLines = (text) => {
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};

// Hero component renders a hero section with background, title, subtitle, and children
// Props:
// - title: Main heading text (supports multi-line)
// - subtitle: Subtitle text (supports multi-line)
// - backgroundImage: URL for the background image
// - titleAlign: Alignment for the title ("center" or "left")
// - subtitleAlign: Alignment for the subtitle ("center" or "left")
// - children: Additional elements to render below the divider
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  primary= false,
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
  children,
  waterMarkImage,
}) {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Overlay for darkening or styling the background image */}
      <div className="hero-overlay">
        <div
          className={`hero-content ${titleAlign === "center" ? "text-center" : "text-left"}`}
        >
          {/* Subtitle with configurable alignment */}
          <p
            style={{ textAlign: subtitleAlign }}
            className={`nav ${primary ? "" : ""}`}
          >
            {renderLines(subtitle)}
          </p>
          {/* Divider appears if title is present */}
          {/* Render any additional children below the divider */}
          {/* Title with configurable alignment */}
          <h2
            className={`font-hero-title ${titleAlign === "center" ? "center" : ""}`}
            style={{ textAlign: titleAlign }}
          >
            {renderLines(title)}
          </h2>
          {title && <div className={`divider align-${titleAlign}`}></div>}
          {children}
          {waterMarkImage && (
            <div className="hero-watermark">
              <img src={waterMarkImage} alt="Watermark" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

// Export the Hero component for use in other parts of the app
export default Hero;
